module.exports = "<app-job-cost-overview *ngIf=\"job.job_is_completed\" [job_id]='job.job_id'></app-job-cost-overview>"